/**
 * @file React context for the upload manager.
 * Prefer {@link useUploadManager} over consuming this context directly.
 * @internal Test utilities may import this until a public mock provider exists.
 */

import { createContext } from 'react';

import type { UploadManagerContextValue } from './types';

/** React context carrying upload manager state and actions. Null outside provider. */
export const UploadManagerContext =
  createContext<UploadManagerContextValue | null>(null);
